import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import moment from 'moment';
import useStyles from './styles';
import { useFormik } from 'formik';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { isValueNumber } from 'src/utils/typeValidators';
import { billSchema } from 'src/utils/formValidation/Allocations';
import RangeDatePicker from 'src/components/general/RangeDatePicker';
import { ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { Button, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Typography } from '@mui/material';
export const FilePreviewModalForm = observer(_ref => {
  let selectedCycleStartDate = _ref.selectedCycleStartDate,
    utility = _ref.utility,
    validator = _ref.validator,
    isDisabledParent = _ref.isDisabledParent,
    calculateFormFromModal = _ref.calculateFormFromModal,
    isDisabled = _ref.isDisabled,
    handleModalClose = _ref.handleModalClose;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isReinitialize = _useState4[0],
    setIsReinitialize = _useState4[1];
  const formik = useFormik({
    initialValues: {
      amount: '',
      commonAreaDeduction: '',
      date: {
        endDate: '',
        startDate: ''
      },
      goodWillDeduction: ''
    },
    enableReinitialize: true,
    validationSchema: billSchema
  });
  const isCycleFromPreviousMonth = () => {
    if (!formik.values.date.startDate) {
      const today = moment().toDate();
      const cycleStartDate = moment(selectedCycleStartDate).toDate();
      return moment(cycleStartDate).isBefore(today, 'month');
    }
  };
  const onChange = e => {
    formik.handleChange(e);
  };
  const onKeyDown = e => {
    if (e.keyCode == 13) {
      e.preventDefault();
    }
  };
  const endAdornment = text => /*#__PURE__*/React.createElement(InputAdornment, {
    position: "end",
    type: "infoTooltip"
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: text,
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    type: "question"
  }))));
  useEffect(() => {
    if (store.files.drawForm.amount || store.files.drawForm.date.endDate || store.files.drawForm.date.startDate) {
      formik.setValues(store.files.drawForm);
    } else {
      formik.setValues(validator.values);
    }
    setIsLoaded(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapper
  }, isLoaded && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.formTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Enter bill details")), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.field, " ").concat(classes.rangeDatePicker)
  }, /*#__PURE__*/React.createElement(RangeDatePicker, {
    disabled: isDisabledParent || isDisabled,
    toDate: formik.values.date.endDate ? moment(formik.values.date.endDate).toDate() : '',
    fromDate: formik.values.date.startDate ? moment(formik.values.date.startDate).toDate() : '',
    handleDateChange: dates => {
      formik.setFieldTouched(formik.values.date);
      formik.handleChange({
        target: {
          id: 'date',
          value: dates
        }
      });
      const cValues = _objectSpread({}, formik.values);
      cValues.date = dates;
      store.files.changeDrawForm(cValues);
    },
    id: "date",
    label: t('allocations.select_dates_range'),
    maxDate: moment(store.allocations.currentCycle.endDateOnly).add(1, 'days').toDate(),
    reinitialize: isReinitialize,
    setIsReinitialize: setIsReinitialize,
    showPreviousMonths: isCycleFromPreviousMonth()
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.field
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "username"
  }, t('allocations.bill_value')), /*#__PURE__*/React.createElement(OutlinedInput, {
    disabled: isDisabledParent || isDisabled,
    endAdornment: endAdornment(t('allocations.should_be_decimal')),
    error: formik.touched.amount && Boolean(formik.errors.amount),
    id: "amount",
    label: t('allocations.bill_value'),
    onChange: onChange,
    onBlur: () => store.files.changeDrawForm(formik.values),
    onKeyDown: onKeyDown,
    placeholder: "0.00",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    type: "float",
    value: formik.values.amount
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.field, " ").concat(classes.fieldSm)
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "username"
  }, t('allocations.cad')), /*#__PURE__*/React.createElement(OutlinedInput, {
    defaultValue: isValueNumber(utility === null || utility === void 0 ? void 0 : utility.commonAreaDeduction) ? utility.commonAreaDeduction : 5,
    disabled: true,
    endAdornment: endAdornment(t('allocations.cad_hint')),
    id: "allocation-method",
    label: t('allocations.cad'),
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "lock-locked"
    })),
    type: "text"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.field, " ").concat(classes.fieldSm)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formControlWithSuffix
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "username"
  }, t('allocations.gwd')), /*#__PURE__*/React.createElement(OutlinedInput, {
    disabled: isDisabledParent || isDisabled,
    endAdornment: endAdornment(t('allocations.gwd_hint')),
    error: formik.touched.goodWillDeduction && Boolean(formik.errors.goodWillDeduction),
    id: "goodWillDeduction",
    label: t('allocations.gwd'),
    onChange: onChange,
    onBlur: () => store.files.changeDrawForm(formik.values),
    onKeyDown: onKeyDown,
    placeholder: "0.00",
    type: "float",
    value: formik.values.goodWillDeduction,
    inputProps: {
      maxLength: 3
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.formControlWithSuffixOutput
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.formControlWithSuffixOutputValue
  }, formik.values.goodWillDeduction), /*#__PURE__*/React.createElement("span", {
    className: classes.formControlWithSuffixOutputSuffixValue
  }, formik.values.goodWillDeduction === '' ? '' : '%')))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.field, " ").concat(classes.fieldSm)
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !formik.isValid || isDisabledParent || isDisabled,
    type: "button",
    variant: "contained",
    onClick: () => {
      calculateFormFromModal(formik.values);
      handleModalClose();
    },
    'custom-attribute': '319-FilePreviewModal'
  }, t('allocations.calculate')))));
});